import {doc} from './docs.js';
import Tone from 'tone';
import {BANG} from 'messaging/message-types.js';
import ZCanvas from "zobject/custom/ZCanvas.js";

doc(
    "metro",
    {},
    "Sends tick every 1/32th step (when project is playing)",
    undefined,
    {
        tags: "Ticker"
    }
);

export const metro = (object, n) => {
    object.needsTick = true;

    return (msg) => {
        return BANG;
    };
};

doc(
    "syncedMetro",
    {},
    "Sends tick every 1/32th step (when project is playing)",
    undefined,
    {
        tags: "Ticker"
    }
);

export const syncedMetro = (object, n) => {
    object.needsTick = true;

    return (msg) => {
        let [type, stepNumber, time] = msg;
        if (type !== 'tick') {
            return;
        }
        setTimeout(() => {
            object.sendMessage(
                object.outputByNumber(0),
                BANG);
        }, (time - Tone.Master.context.currentTime)*1000);
    };
};


doc(
    "setInterval",
    {},
    "Sends every so often",
    undefined,
    {
        tags: "Ticker"
    }
);

export const setInterval= (object, n) => {
    let interval = window.setInterval(() => {
        if (object && object.function) {
            object.bang();
        }
    }, 80);

    return (msg) => {
        if (msg[0] === "dispose") {
            clearInterval(interval);
            return;
        }
        return BANG;
    };
};

doc(
    "setIntervalFast",
    {},
    "Sends every so often",
    undefined,
    {
        tags: "Ticker"
    }
);

export const setIntervalFast = (object, n) => {
    let interval = window.setInterval(() => {
        if (object && object.function) {
            object.bang();
        }
    }, 15);

    return (msg) => {
        if (msg[0] === "dispose") {
            clearInterval(interval);
            return;
        }
        return BANG;
    };
};


